import { createFileRoute } from '@tanstack/react-router';
import { RecordShiftWizard } from '../../../features/production-packconv/components/RecordShiftWizard';

/** Owned by G21. Default tab of the production-packconv screen group — "Record a
 * shift" (BUILD_SPEC.md §8.3 SHIFT mode), matching HOME_TASKS's task button which
 * routes straight to `/production-packconv`. */
export const Route = createFileRoute('/_authenticated/production-packconv/')({
  component: RecordShiftWizard,
});
